"use strict";
/* Config file should be manually updated every time on-chain program updates */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Side = exports.SortBy = exports.WeightTime = exports.FilterTime = exports.WeightType = exports.FilterType = exports.BasketError = exports.ADDITIONAL_UNITS = exports.ADDITIONAL_FEE = exports.BPS_DIVIDER = exports.EXPO_DIVIDER = exports.WEIGHT_MULTIPLIER = exports.NUM_OF_TOKENS_IN_ASSET_POOL = exports.NUM_OF_TOKENS_IN_BASKET = exports.COMBINED_TOKENS_IN_A_BASKET = exports.NUM_OF_DAYS_IN_DATABASE = exports.BEYOND_LST_BASKET = exports.JUP_AGGREGATOR = exports.PRISM_AGGREGATOR = exports.SWAP_FEE_ACCOUNT = exports.REBALANCE_FEE_ACCOUNT = exports.REBALANCE_FEE_WALLET = exports.BUY_FEE_WALLET = exports.BUY_FEE_ACCOUNT = exports.CREATE_FEE_ACCOUNT = exports.CURVE_DATA_ADDRESS = exports.DATABASE_ADDESS = exports.TOKEN_STATS_ADDRESS = exports.TOKEN_LIST_ADDRESS = exports.BASKETS_LOOKUP_TABLE = exports.BASKETS_PROGRAM_PDA = exports.BASKETS_PROGRAM_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.BASKETS_PROGRAM_ID = new web3_js_1.PublicKey("2KehYt3KsEQR53jYcxjbQp2d2kCp4AkuQW68atufRwSr");
exports.BASKETS_PROGRAM_PDA = new web3_js_1.PublicKey("BLBYiq48WcLQ5SxiftyKmPtmsZPUBEnDEjqEnKGAR4zx");
exports.BASKETS_LOOKUP_TABLE = new web3_js_1.PublicKey("4Bp4czjcokF4WSvLaqnhA4vdRWwV1k3JB5zEUkVRfF1M");
exports.TOKEN_LIST_ADDRESS = new web3_js_1.PublicKey("3SnUughtueoVrhevXTLMf586qvKNNXggNsc7NgoMUU1t");
exports.TOKEN_STATS_ADDRESS = new web3_js_1.PublicKey("5u1AuCafhCtWENUo3m2aLKtDuoQQfWzr2bb5bDJzD47q");
exports.DATABASE_ADDESS = new web3_js_1.PublicKey("2FC4kaLTtyqSypK9rZiSMvsM3WkA6kz9CUmu57h9wecb");
exports.CURVE_DATA_ADDRESS = new web3_js_1.PublicKey("4QMjSHuM3iS7Fdfi8kZJfHRKoEJSDHEtEwqbChsTcUVK");
exports.CREATE_FEE_ACCOUNT = new web3_js_1.PublicKey("AWfpfzA6FYbqx4JLz75PDgsjH7jtBnnmJ6MXW5zNY2Ei");
exports.BUY_FEE_ACCOUNT = new web3_js_1.PublicKey("48jWdAAChBznvLngKcRMBvJZ19VbuzU7WYgNtCaQgvK7");
exports.BUY_FEE_WALLET = new web3_js_1.PublicKey("AWfpfzA6FYbqx4JLz75PDgsjH7jtBnnmJ6MXW5zNY2Ei");
exports.REBALANCE_FEE_WALLET = new web3_js_1.PublicKey("2WEjwiy3W8U3EJ5E8Zgm2kWKzEDdndboiyVJnv6yqUYB");
exports.REBALANCE_FEE_ACCOUNT = new web3_js_1.PublicKey("CXwdWJaxyMAZA88UPs3CXMKo4ykEv8No4xLWPVGmMS3L");
exports.SWAP_FEE_ACCOUNT = new web3_js_1.PublicKey("AWfpfzA6FYbqx4JLz75PDgsjH7jtBnnmJ6MXW5zNY2Ei");
exports.PRISM_AGGREGATOR = new web3_js_1.PublicKey("AGGZ2djPDEvrbgiBTV3P8UoB8Zf1kGawkWd2eu553o44");
exports.JUP_AGGREGATOR = new web3_js_1.PublicKey("JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4");
exports.BEYOND_LST_BASKET = new web3_js_1.PublicKey("5GPvpZ9Jga9JoZ5eVQms9hQARwexmCjuqDaTxF6LMdsF");
exports.NUM_OF_DAYS_IN_DATABASE = 460;
exports.COMBINED_TOKENS_IN_A_BASKET = 15;
exports.NUM_OF_TOKENS_IN_BASKET = 20;
exports.NUM_OF_TOKENS_IN_ASSET_POOL = 200;
exports.WEIGHT_MULTIPLIER = 10000;
exports.EXPO_DIVIDER = 100;
exports.BPS_DIVIDER = 10000;
exports.ADDITIONAL_FEE = 15000;
exports.ADDITIONAL_UNITS = 1000000;
class BasketError extends Error {
    constructor(message, txId = "") {
        super(message);
        this.txId = txId;
    }
}
exports.BasketError = BasketError;
var FilterType;
(function (FilterType) {
    FilterType[FilterType["Fixed"] = 0] = "Fixed";
    FilterType[FilterType["MarketCap"] = 1] = "MarketCap";
    FilterType[FilterType["Volume"] = 2] = "Volume";
    FilterType[FilterType["Performance"] = 3] = "Performance";
})(FilterType || (exports.FilterType = FilterType = {}));
var WeightType;
(function (WeightType) {
    WeightType[WeightType["Fixed"] = 0] = "Fixed";
    WeightType[WeightType["MarketCap"] = 1] = "MarketCap";
    WeightType[WeightType["Volume"] = 2] = "Volume";
    WeightType[WeightType["Performance"] = 3] = "Performance";
})(WeightType || (exports.WeightType = WeightType = {}));
var FilterTime;
(function (FilterTime) {
    FilterTime[FilterTime["Day"] = 0] = "Day";
    FilterTime[FilterTime["Week"] = 1] = "Week";
    FilterTime[FilterTime["Month"] = 2] = "Month";
    FilterTime[FilterTime["Quarter"] = 3] = "Quarter";
    FilterTime[FilterTime["HalfYear"] = 4] = "HalfYear";
    FilterTime[FilterTime["Year"] = 5] = "Year";
})(FilterTime || (exports.FilterTime = FilterTime = {}));
var WeightTime;
(function (WeightTime) {
    WeightTime[WeightTime["Day"] = 0] = "Day";
    WeightTime[WeightTime["Week"] = 1] = "Week";
    WeightTime[WeightTime["Month"] = 2] = "Month";
    WeightTime[WeightTime["Quarter"] = 3] = "Quarter";
    WeightTime[WeightTime["HalfYear"] = 4] = "HalfYear";
    WeightTime[WeightTime["Year"] = 5] = "Year";
})(WeightTime || (exports.WeightTime = WeightTime = {}));
var SortBy;
(function (SortBy) {
    SortBy[SortBy["DescendingOrder"] = 0] = "DescendingOrder";
    SortBy[SortBy["AscendingOrder"] = 1] = "AscendingOrder";
})(SortBy || (exports.SortBy = SortBy = {}));
var Side;
(function (Side) {
    Side[Side["To"] = 0] = "To";
    Side[Side["From"] = 1] = "From";
})(Side || (exports.Side = Side = {}));
